





















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getSeedKpDetail, setKpField, updateKpField, deleteKp, gradeByPm } from '@/api/kp';
import { mapGetters } from 'vuex';
import kpEdit from '@/components/kp/kpEdit.vue';
import { hasPermission } from '@/utils/utils';

const gradeList = ['S', 'A', 'A-', 'B+', 'B', '待定', 'KP'];

@Component({
  components: { kpEdit },
  computed: { ...mapGetters(['userInfo']) }
})
class KPDetail extends Vue {
  dataInfo: object = {
    maintainer: '',
    maintainerAid: [],
    createAt: '',
    educationExperience: '',
    workExperience: '',
    individuality: '',
    startupMaturity: '',
    CEOSuitability: '',
    maintenanceStrategy: ''
  };
  showDevelopment: boolean = false;
  showDevelopmentType: number = 0; // 0是新建,1是编辑
  developmentNow: string = '';
  // developmentTmp: string = '';
  developmentId: string = '';
  showKpEdit: boolean = false;
  kpEditInfo: object = {};
  kpEditType: string = 'new';
  confirmLoading: boolean = false;
  showEditGrade: boolean = false;
  showDelete: boolean = false;
  grade: string = '';
  hasPermission: boolean = false;
  userInfo: any;
  gradeList: any[] = gradeList;
  gradeTmp: string = '';
  btnLoading: boolean = false;

  get bindProject() {
    // @ts-ignore
    return this.dataInfo.baseInfo ? this.dataInfo.baseInfo.bindSources.includes('2') || this.dataInfo.baseInfo.source === 2 : false;
  }

  created() {
    this.getDetail();
    const { permissions: queue } = this.userInfo || {};
    this.hasPermission = hasPermission(queue, '/bp/seed/grade');
  }

  // transform str to DOM and return the innerText of the DOM
  getText(str) {
    let div = document.createElement('div');
    div.innerHTML = str;
    return div.innerText;
  }

  clickDelete() {
    // let _this = this;
    // this.$confirm({
    //   // title: '是否确认？',
    //   width: 500,
    //   content: '客户信息删除将不可恢复,是否确认删除?',
    //   onOk() {
    //     _this.deleteKp();
    //   },
    //   onCancel() {}
    //   // class: 'test'
    // });
    this.showDelete = true;
  }

  async deleteKp(type) {
    try {
      let res = await deleteKp({
        kpId: this.$route.query.id,
        unbindCompany: type // 1-默认 0-不解除
      });
      if (res.code === 200) {
        this.$message.success('删除成功');
        this.$router.push('/kp/seed');
      }
    } catch (err) {
      console.log(err);
    }
  }

  async getDetail() {
    try {
      let res = await getSeedKpDetail({ kpId: this.$route.query.id });
      if (res.code === 200) {
        let dataInfo = res.data;
        dataInfo.educationExperience.value = dataInfo.educationExperience.value.replace(/<a href/g, '<a target="_blank" href');
        dataInfo.workExperience.value = ((dataInfo.workExperience || {}).value || '').replace(/<a href/g, '<a target="_blank" href');
        dataInfo.individuality.value = dataInfo.individuality.value.replace(/<a href/g, '<a target="_blank" href');
        if (dataInfo.info) {
          dataInfo.info.value = dataInfo.info.value.replace(/<a href/g, '<a target="_blank" href');
        } else {
          dataInfo.info = { value: '' };
        }
        (dataInfo.latestDevelopment || []).forEach(_ => {
          _.value = _.value.replace(/<a href/g, '<a target="_blank" href');
        });
        this.dataInfo = dataInfo;
        this.grade = this.dataInfo['gradeByPM'] ? this.dataInfo['gradeByPM'].value : '';
        console.log(this.dataInfo);
      }
    } catch (err) {
      console.log(err);
    }
  }

  openDevelopment(e, id, content, i) {
    this.developmentId = id ? id : 0;

    this.showDevelopment = true;
    this.showDevelopmentType = e;
    if (!content) {
      this.developmentNow = '';
    } else {
      this.$nextTick(() => {
        //@ts-ignore
        this.developmentNow = this.getText(content);
      });
    }
  }

  openKpEdit(type) {
    this.kpEditInfo = this.dataInfo;
    this.kpEditType = type;
    this.showKpEdit = true;
  }

  hideKpEdit(type) {
    this.kpEditInfo = {};
    this.showKpEdit = false;
    if (type === 'edit') {
      this.getDetail();
    }
  }

  async submitDevelopment() {
    this.confirmLoading = true;
    let res;
    if (this.showDevelopmentType === 0) {
      res = await setKpField({
        kpId: this.dataInfo['baseInfo'].id,
        source: 1,
        latestDevelopment: this.developmentNow
      });
    } else {
      let body = {};
      body[this.developmentId] = this.developmentNow;
      res = await updateKpField(body);
    }
    if (res.code === 200) {
      this.$message.success('提交成功');
      this.developmentNow = '';
      this.getDetail();
      this.showDevelopment = false;
    }
    this.confirmLoading = false;
  }

  editGrade() {
    this.showEditGrade = true;
    this.gradeTmp = this.grade;
  }

  async saveGrade() {
    try {
      this.btnLoading = true;
      let res = await gradeByPm({
        kpId: this.$route.query.id,
        grade: this.gradeTmp
      });
      this.btnLoading = false;
      if (res.code === 200) {
        this.$message.success('保存成功');
        this.showEditGrade = false;
        this.getDetail();
      }
    } catch (err) {
      console.log(err);
    }
  }
}

export default KPDetail;
